export default "__VITE_ASSET__e5449340__"